<template>
  <div class="devicelist">
    <!-- <div class="btnbox">
      <el-button class="add-btn" @click="add" icon="el-icon-plus"
        >添加设备</el-button
      >
    </div> -->
    <div class="top">
      <div class="querybox">
        <div>
          <p>质检员账号：</p>
          <el-input
            v-model="queryParams.qualityTestingAccount"
            placeholder="请输入质检员账号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>质检员名字：</p>
          <el-input
            v-model="queryParams.qualityTestingName"
            placeholder="请输入质检员名字"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>质检状态：</p>
          <el-select
            v-model="queryParams.qualityTestingStatus"
            placeholder="请选择质检状态"
          >
            <el-option
              v-for="item in getDictDatas(DICT_TYPE.QUALITY_TESTING_STATUS)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p>设备名称：</p>
          <el-input
            v-model="queryParams.deviceName"
            placeholder="请输入设备名称"
            clearable
          ></el-input>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="qualityTestingName" label="质检员">
        </el-table-column>
        <el-table-column prop="qualityTestingAccount" label="账号">
        </el-table-column>
        <!-- <el-table-column prop="id" label="质检设备id"> </el-table-column> -->
        <el-table-column prop="deviceName" label="设备名称"> </el-table-column>
        <el-table-column prop="createdTime" label="质检时间" min-width="120">
        </el-table-column>
        <el-table-column prop="qualityTestingStatus" label="质检状态">
          <template slot-scope="{ row }">
            <el-button class="green-btn" v-if="row.qualityTestingStatus === 0"
              >正常</el-button
            >
            <el-button
              class="blue-btn"
              v-else-if="row.qualityTestingStatus === 2"
              >其他</el-button
            >
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.qualityTestingNotes"
              placement="top-start"
              v-else
            >
              <el-button class="red-btn">不合格</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" fixed="right" min-width="100">
          <template slot-scope="scope">
            <el-button
              class="textOrange-btn"
              @click="goEdit(scope.row)"
              style="margin-right: 10px"
              >修改状态</el-button
            >
            <el-popconfirm
              title="是否删除该设备？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(scope.row.id)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 修改状态 -->
    <el-dialog
      :visible.sync="statusVisible"
      width="30%"
      :before-close="statusClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>修改状态</p>
        <span @click="statusClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="status-box">
        <el-radio-group v-model="qualityTestingStatus">
          <template
            v-for="item in getDictDatas(DICT_TYPE.QUALITY_TESTING_STATUS)"
          >
            <el-radio
              :key="item.value"
              :label="item.value"
              v-if="item.value !== 2"
              >{{ item.label }}</el-radio
            >
          </template>
        </el-radio-group>
        <el-input
          v-if="isInput"
          placeholder="输入不合格原因"
          show-word-limit
          maxlength="20"
          v-model="qualityTestingNotes"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="statusClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitStatus()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加设备 -->
    <el-dialog
      :visible.sync="addVisible"
      title="添加设备"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>添加设备</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <el-form
          :model="staffForm"
          :rules="staffRules"
          ref="staffForm"
          class="demo-staffForm"
          label-position="left"
          label-width="120px"
        >
          <el-form-item label="质检员账号：" prop="qualityTestingAccount">
            <el-input
              v-model="staffForm.qualityTestingAccount"
              placeholder="请输入质检员账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="质检码(密码)：" prop="qualityTestingCode">
            <el-input
              v-model="staffForm.qualityTestingCode"
              placeholder="请输入质检码(密码)"
            ></el-input>
          </el-form-item>
          <el-form-item label="SN码：" prop="snCode">
            <el-input
              v-model="staffForm.snCode"
              placeholder="请输入SN码"
            ></el-input>
          </el-form-item>
          <el-form-item class="handlebox">
            <el-button
              type="primary"
              @click="submitForm('staffForm')"
              class="enter-btn save-btn"
              :loading="submitLoading"
              >保存</el-button
            >
            <el-button
              @click="resetForm('staffForm')"
              class="cancel-btn calloff-btn"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceList,
  deleteDevice,
  editDevice,
  addDevice,
} from "@/api/device";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        qualityTestingAccount: "",
        qualityTestingName: "",
        qualityTestingStatus: "",
        deviceName: "",
      },
      tableData: [],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      statusVisible: false,
      qualityTestingStatus: 0,
      itemInfo: {},
      qualityTestingNotes: "",
      addVisible: false,
      staffForm: {
        qualityTestingAccount: "",
        qualityTestingCode: "",
        snCode: "",
      },
      staffRules: {
        qualityTestingAccount: [
          { required: true, message: "请输入质检员账号", trigger: "blur" },
          {},
        ],
        qualityTestingCode: [
          { required: true, message: "请输入质检码", trigger: "blur" },
          {},
        ],
        snCode: [
          { required: true, message: "请输入SN码", trigger: "blur" },
          {},
        ],
      },
      submitLoading: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    isInput() {
      return this.qualityTestingStatus === 1 ? true : false;
    },
  },
  mounted() {},
  methods: {
    //获取设备列表
    async init() {
      const res = await getDeviceList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.qualityTestingAccount = "";
      this.queryParams.qualityTestingName = "";
      this.queryParams.qualityTestingStatus = "";
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.queryParams.deviceName = "";
      this.value = "";
      this.init();
    },
    timeChange(event) {
      console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event[0])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment(event[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    // 删除
    async deleteFn(id) {
      await deleteDevice({ id });
      this.$message.success("删除成功");
      this.init();
    },
    // 修改状态
    goEdit(item) {
      this.itemInfo = item;
      this.statusVisible = true;
    },
    statusClose() {
      this.statusVisible = false;
    },
    async sumbitStatus() {
      const { qualityTestingNotes, qualityTestingStatus } = this;
      const params = {
        qualityTestingNotes,
        qualityTestingStatus,
        id: this.itemInfo.id,
      };
      await editDevice(params);
      this.statusVisible = false;
      this.qualityTestingNotes = "";
      this.qualityTestingStatus = 0;
      this.init();
    },
    handleClose() {
      this.addVisible = false;
    },
    // 添加
    add() {
      this.addVisible = true;
    },
    // 添加设备
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = {
            qualityTestingAccount: this.staffForm.qualityTestingAccount,
            qualityTestingCode: this.staffForm.qualityTestingCode,
            snCode: this.aes_encrypt(this.staffForm.snCode),
          };
          this.submitLoading = false;
          await addDevice(params);
          this.$message.success("添加成功！");

          this.resetForm(formName);
          this.resetFn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.handleClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.devicelist {
  position: relative;
  > .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        > span {
          display: block;
          width: 15px;
          height: 1px;
          background: #979797;
          margin: 0 6px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
          min-width: 100px;
          // width: 100px;
        }
        .el-input,
        .el-range-editor {
          width: 200px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  ::v-deep .demo-staffForm {
    width: 80%;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      white-space: nowrap;
      width: 120px !important;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
    }
    .el-form-item__content {
      width: 0;
      flex: 1;
      margin: 0 !important;
    }
    .handlebox {
      text-align: right;
      margin-top: 50px;
    }
    // .el-input {
    //   width: 380px;
    // }
  }
  ::v-deep .is-checked {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
  ::v-deep .is-indeterminate {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
  ::v-deep .status-box {
    width: 100%;
    .el-radio {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-radio__label {
        color: rgba(0, 0, 0, 0.85);
      }
      .el-radio__inner {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }
      .is-checked {
        .el-radio__inner {
          border: 1px solid #ff5d2f;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background: #ff5d2f;
        }
      }
    }
    .el-input {
      margin-top: 24px;
    }
    input[aria-hidden="true"] {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      box-shadow: none !important;
    }
  }
}
</style>
